import type {TFunction} from "i18next";

const STATUS_CATALOG_KEYS: Partial<Record<string, "status.unpublish" | "status.published">> = {
  unscheduled: "status.unpublish",
  scheduled: "status.published",
};

/** Shift status badge / filter label (existing catalog keys only). */
export function tShiftStatusLabel(status: string, tShifts: TFunction<"shifts">): string {
  const key = STATUS_CATALOG_KEYS[status];
  if (key) return tShifts(key);

  // active, completed, cancelled, no_show — see docs/plans/2026-09-09-i18n-catalog-gaps.md
  return status.replace(/_/g, " ");
}
